export default {
  modules: {
    chat: true,
    inbox: true,
    medical: true,
    symptom: true,
    healthtips: false,
    profile: true,
    documents: false,
    emergency: false,
    coronavirus: true
  },
  practitioner: {
    type: 'doctor',
    plural_type: 'doctors'
  },
  app: {
    name: 'DrDoctor',
    endpoint: 'https://medi4u.co.za/doctor/'
  },
  registration: {
    simple: false
  },
  permissions: [
    'android.permission.RECORD_AUDIO',
    'android.permission.WRITE_EXTERNAL_STORAGE',
    'android.permission.CALL_PHONE',
    'android.permission.CAMERA',
    'android.permission.ACCESS_FINE_LOCATION'
  ],
  requiresLocation: false
}
